import React from 'react';
import { Alert as ReactstrapAlert, AlertProps } from 'reactstrap';
import dangerIcon from '../../../assets/icon-16-px-danger.png';
import warningIcon from '../../../assets/icon-16px-warning.svg';

export interface CustomAlertProps extends AlertProps {
  color: 'success' | 'primary' | 'warning' | 'danger' | 'info';
  hideIcon?: boolean;
}

export const Alert = ({ style, ...props }: CustomAlertProps) => (
  <ReactstrapAlert
    style={{
      background: backgroundColorFromProps(props),
      borderColor: borderColorFromColorProps(props),
      color: borderColorFromColorProps(props),
      padding: 0,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      display: 'flex',
      ...style,
    }}
    {...props}
    color={props.color}
  >
    {!props.hideIcon ? iconFromColorProps(props) : <div style={{ margin: '10px' }} />}
    <div
      style={{
        margin: '10px 0',
        display: 'inline-block',
        color: '#3d3d3d',
        width: '100%',
        paddingRight: 10,
      }}
    >
      {props.children}
    </div>
  </ReactstrapAlert>
);

const iconFromColorProps = (props: CustomAlertProps) => {
  switch (props.color) {
    case 'success':
      return <img alt='success' style={{ margin: '10px' }} src='/assets/images/icons/icon-16-px-success-green.svg' />;
    case 'danger':
      return <img alt='danger' style={{ margin: '10px' }} src={dangerIcon} />;
    case 'info':
      return (
        <img alt='information' style={{ margin: '10px' }} src='/assets/images/icons/icon-16-px-information-blue.svg' />
      );
    case 'warning':
      return <img alt='danger' style={{ margin: '10px' }} src={warningIcon} />;

    default:
      return <div />;
  }
};

const borderColorFromColorProps = (props: CustomAlertProps) => {
  switch (props.color) {
    case 'success':
      return '#1fc881';
    case 'danger':
      return '#FF4444';
    case 'info':
      return '#4078fa';
    case 'warning':
      return '#FFAB00';
    default:
      return 'inherit';
  }
};

const backgroundColorFromProps = (props: CustomAlertProps) => {
  switch (props.color) {
    case 'success':
      return 'rgba(31, 200, 129, 0.1)';
    case 'danger':
      return 'rgba(253, 50, 56, 0.1)';
    case 'info':
      return 'rgba(64, 120, 250, 0.1)';
    case 'warning':
      return 'rgba(255, 238, 204, 0.9)';
    default:
      return 'inherit';
  }
};
